import { Link } from 'react-router-dom';
import { Clock, TrendingUp, Star, Users } from 'lucide-react';

const featuredSections = [
  {
    name: 'Last Minute',
    path: '/last-minute',
    icon: Clock,
    gradient: 'from-red-600 to-red-800',
    description: 'Oferte de ultimă oră'
  },
  {
    name: 'Early Booking',
    path: '/early-booking',
    icon: TrendingUp,
    gradient: 'from-emerald-600 to-emerald-800',
    description: 'Rezervă devreme, economisești'
  },
  {
    name: 'Populare',
    path: '/populare',
    icon: Star,
    gradient: 'from-amber-500 to-amber-700',
    description: 'Cele mai căutate'
  },
  {
    name: 'Ultimele Rezervări',
    path: '/ultimele-rezervari',
    icon: Users,
    gradient: 'from-blue-600 to-blue-800',
    description: 'Ce aleg alții'
  }
];

export const FeaturedSections = () => {
  return (
    <section className="py-16 md:py-24" data-testid="featured-sections">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-white mb-3">
            Oferte speciale
          </h2>
          <p className="text-white/60">
            Cele mai avantajoase pachete turistice
          </p>
        </div>

        <div className="featured-grid">
          {featuredSections.map((section, index) => {
            const Icon = section.icon;
            return (
              <Link
                key={section.path}
                to={section.path}
                className={`relative overflow-hidden rounded-2xl h-36 md:h-44 bg-gradient-to-br ${section.gradient} card-hover gold-glow-hover group animate-fade-in`}
                style={{ animationDelay: `${index * 100}ms` }}
                data-testid={`featured-${section.name.toLowerCase().replace(' ', '-')}`}
              >
                {/* Pattern overlay */}
                <div className="absolute inset-0 opacity-10">
                  <div className="absolute inset-0" style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                  }} />
                </div>

                <div className="absolute inset-0 z-10 flex flex-col items-center justify-center p-4">
                  <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center mb-3 group-hover:scale-110 transition-transform">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="font-heading font-bold text-xl text-white text-center mb-1">
                    {section.name}
                  </h3>
                  <p className="text-white/80 text-sm">
                    {section.description}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};
